{
  "#MDE_BESTELLVORSCHLAG": { },

  "#MDE_INVENTUR": {
    "STEPS": {
      "LAGER": {
        "TITLE": "Lager-Auswahl",
        "DESCRIPTION": "Bitte Lager für die Inventur auswählen!"
      },
      "LAGERPLATZ": {
        "TITLE": "Lagerplatz",
        "DESCRIPTION": "Bitte Lagerplatz eingeben oder scannen!"
      },
      "BELEGDATUM": {
        "TITLE": "Belegdatum",
        "DESCRIPTION": "Bitte gewünschtes Belegdatum eingeben"
      }
    }
  }
}
